// ========== Start Open & Close Compare fits popup ==========
const compareFitsPopup = document.querySelector('.compare-fits');

// ~~~~~~~~~~ Start Helper functions ~~~~~~~~~~
const opencompareFitsModal = (compareFitsPopup) => {
  compareFitsPopup.classList.remove('hidden');
  document.body.style.overflow = "hidden";
}

const closecompareFitsModal = (compareFitsPopup) => {
  compareFitsPopup.classList.add('hidden');
  document.body.style.overflow = "auto";
}
// ~~~~~~~~~~ End Helper functions ~~~~~~~~~~

const compareFitsFunction = function() {
  const compareFitsbtns = document.querySelectorAll('.compare-fits-btn');
  const compareFitsClose = document.querySelector('.compare-fits__close');

  // Open Compare fits 
  compareFitsbtns.forEach(btn => {
    btn.addEventListener('click', () => opencompareFitsModal(compareFitsPopup));
  })

  // Close Compare fits
  compareFitsClose.addEventListener('click', () => closecompareFitsModal(compareFitsPopup));
  compareFitsPopup.addEventListener('click', function(e) {if (e.target === this) closecompareFitsModal(compareFitsPopup)});
  window.addEventListener('keydown', e => {if (e.key === 'Escape') closecompareFitsModal(compareFitsPopup)});
}

document.addEventListener('DOMContentLoaded', () => {
  if (compareFitsPopup) compareFitsFunction()
});
// ========== End Open & Close Compare fits popup ==========





